import React, { useContext, useState } from "react";

import { AuthContext } from "../../context/authContext";

import { Box, Typography, Container, Grid, SvgIcon } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { StartTestButton } from "./styled";

import plechaInicio from "../../img/tester/inicio-test-retos-bi-en-linea.webp";

import { ReactComponent as ArrowButton } from "../../img/tester/svg/arrow-right-circle.svg";

import { FullScreenWrapper } from "../Entry/styled";

import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";

export default function TesterRecompensas() {
  const { idCliente, logout } = useContext(AuthContext);
  const isLoggedIn = !!idCliente;
  const navigate = useNavigate();

  const handleStartTest = () => {
    navigate("/questions-test");
  };

  return (
    <FullScreenWrapper>
      {!isLoggedIn && <Header />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minHeight: "100vh",
          position: "relative",
          zIndex: 2,
        }}
      >
        <Grid
          container
          spacing={4}
          alignItems="center"
          sx={{ flexWrap: { xs: "wrap", md: "nowrap" } }}
        >
          {/* Sección izquierda */}
          <Grid
            item
            xs={12}
            md={5}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Box
              component="img"
              src={plechaInicio}
              alt="Test Financiero - Banco Industrial"
              sx={{
                width: "100%",
                height: "auto",
                maxWidth: {
                  xs: "280px",
                  sm: "300px",
                  md: "350px",
                  lg: "375px",
                },
                objectFit: "contain",
                display: "block",
                margin: "0 auto",
              }}
            />
          </Grid>

          {/* Sección derecha */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{ padding: { xs: "32px", md: "0px" }, marginLeft: "32px" }}
          >
            <Typography
              variant="h4"
              sx={{
                color: "#ffb81b",
                fontWeight: "800",
                mb: 0,
                fontSize: { xs: "1.5rem", md: "2rem" },
              }}
            >
              Bienvenido al
            </Typography>

            <Typography
              variant="h2"
              sx={{
                color: "#003864",
                fontWeight: "900",
                mb: 2,
                fontSize: { xs: "2rem", md: "2.5rem" },
                lineHeight: 1.1,
              }}
            >
              Test Financiero
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: "#003864",
                fontWeight: "400",
                mb: 4,
                fontSize: { xs: "1rem", md: "1.25rem" },
                lineHeight: 1.4,
              }}
            >
              Realiza el test que te ayudará a evaluar tu bienestar financiero y
              que acciones tomar para exponenciar tu potencial.
            </Typography>

            <StartTestButton
              id="Btn-empezar-test-retos"
              variant="contained"
              onClick={handleStartTest}
              endIcon={
                <SvgIcon
                  component={ArrowButton}
                  inheritViewBox
                  sx={{ fontSize: "2rem" }}
                />
              }
            >
              Empezar test
            </StartTestButton>
          </Grid>

          <Grid
            item
            xs={12}
            md={5}
            sx={{ display: { xs: "block", md: "none" } }}
          >
            <Box
              component="img"
              src={plechaInicio}
              alt="Test Financiero - Banco Industrial"
              sx={{
                width: "100%",
                height: "auto",
                maxWidth: {
                  xs: "280px",
                  sm: "350px",
                  md: "400px",
                  lg: "450px",
                },
                objectFit: "contain",
                display: "block",
                margin: "0 auto",
              }}
            />
          </Grid>
        </Grid>
      </Box>
      {!isLoggedIn && <Footer />}
    </FullScreenWrapper>
  );
}
